/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useAsset = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlPathNames = window.location.pathname.split('/');
    console.log(`url pathname collectibles`, urlPathNames);
    let category = urlPathNames.slice(-1);
    console.log(`url pathname 2`, category);
    // let id = urlParams.get("id");

    
    if(category) {
        category = String(category).trim()
    }
  
    return {
      
        category,
  
    };
};